export default __webpack_public_path__ + "static/media/ic_download.36ec229f.svg";